import React from 'react';
import ProjectsCarousel from './ProjectsCarousel';

function Projects() {
  return (
    <div className="p-4 sm:mx-8 md:mx-10 h-full flex flex-col justify-center">
      <h1 className="text-lightGreen font-bold text-2xl lg:text-3xl xl:text-4xl mb-2 md:my-4 2xl:mb-7 self-start">
        Projects
      </h1>
      <p className="text-slate-100 sm:text-lg md:text-xl xl:text-2xl self-start mb-5 xl:mb-8 2xl:mb-16">
        Know some of the things I've created
      </p>
      {/* <ProjectsCard /> */}
      <ProjectsCarousel />
    </div>
  );
}

export default Projects;